module.exports = "<p>\r\n  info-box works!\r\n</p>\r\n"